<div class="label">
    <div class="label-title" id="label">
        {{ title | translate }}
    </div>
</div>
